import { Button, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { useNavigate, useRevalidator } from "react-router";

import { ROUTES } from "~/constants/routing";

import styles from "./ServiceUnavailablePage.module.scss";

export const ServiceUnavailablePage: FC = () => {
  const navigate = useNavigate();
  const { revalidate, state } = useRevalidator();

  return (
    <main className={styles.root}>
      <Typography variant="h3" component="h1" sx={{
        fontWeight: 600
      }}>
        Temporarily unavailable
      </Typography>
      <Typography
        align="center"
        sx={{
          paddingLeft: 3,
          paddingRight: 3
        }}>
        We’re getting more requests than usual. Please try again in a moment.
      </Typography>
      <Stack
        sx={{
          flexDirection: "row",
          gap: 2,
          marginTop: 6
        }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => navigate(ROUTES.main.createURL())}
        >
          Go Home
        </Button>
        <Button
          variant="contained"
          color="primary"
          loading={state === "loading"}
          onClick={() => void revalidate()}
        >
          Try again
        </Button>
      </Stack>
    </main>
  );
};
